import type { Achievement } from "../achievement.types";
import { allMoves, shareOf } from "../moveHistory";

export const slowAndSteadyAchievement: Achievement = {
  id: "slowAndSteady",
  name: "Slow and Steady",
  icon: "turtle",
  description: "Won choosing the most similar word two moves in three.",
  isProgressive: true,
  // Over every move made, backtracked ones included.
  // Most similar neighbour chosen on at least 66% of moves.
  check: (gameReport, gameStatus) => {
    if (gameStatus !== "won" || !gameReport) return false;
    const moves = allMoves(gameReport);
    if (moves.length === 0) return false;
    return shareOf(moves, (m) => m.choseMostSimilarNeighbor === true) >= 0.66;
  },
};
